// extracted by mini-css-extract-plugin
export default {"largeScreenWidth":"70","mediumScreenWidth":"38","projectDetailsWidth":"46","carouselItem":"CarouselItem_carouselItem__kYGFn","zoomable":"CarouselItem_zoomable__yJ-Nu"};